export default __webpack_public_path__ + "static/media/as.a8f05fbe.svg";